module.exports = __webpack_public_path__ + "img/imgs5.e67fc078.png";